import { shape, string, arrayOf } from 'prop-types';
import multipleFiltersAttributesShape from './multipleFiltersAttributesShape';

export default shape({
    pastilles: arrayOf(
        shape({
            attributes: multipleFiltersAttributesShape,
            name: string,
        }),
    ).isRequired,
    name: string,
    title: string,
    captionTitle: string,
});
